import React, { useState } from "react";
import { useStyles } from "./InscriptionsLibres.css";
import { Grid, Step, StepLabel, Stepper, Typography, Box, } from "@material-ui/core";
import ChoixDates from "../ChoixDates/ChoixDates2";
import Notes from "../Notes/Notes2";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getActsDatesDispo,
  getAvailablesActivites,
} from "../../../actions/activites";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const InscriptionsLibres = (props) => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const steps = ["Sélection des disponibilités", "Remarques"];
  const [notesTH, setNotesTH] = useState("");
  const [notesGeneral, setNotesGenerale] = useState("");
  const [selectedValues, setSelectedValues] = useState([]);
  const [selectedActivity, setSelectedActivity] = useState([]);
  const manifInfo = props.manifInfo;
  const matches = useMediaQuery("(max-width:570px)");

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <ChoixDates
            manifInfo={manifInfo}
            setActiveStep={setActiveStep}
            selectedValues={selectedValues}
            setSelectedValues={setSelectedValues}
            selectedActivity={selectedActivity}
            setSelectedActivity={setSelectedActivity}
          />
        );
      case 1:
        return (
          <Notes
            manifInfo={manifInfo}
            setActiveStep={setActiveStep}
            notesTH={notesTH}
            setNotesTH={setNotesTH}
            notesGeneral={notesGeneral}
            setNotesGenerale={setNotesGenerale}
            selectedValues={selectedValues}
            setSelectedValues={setSelectedValues}
          />
        );
      default:
    }
  };

  return (
    <Box>
      <Grid container>
        <Grid item xs={12}>
          <Stepper
            activeStep={activeStep}
            orientation={!matches ? "horizontal" : "vertical"}
            className={classes.stepper}
            style={{ borderRadius: 8 }}
          >
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel
                  StepIconProps={{
                    classes: {
                      root: classes.stepIcon,
                      active: classes.activeStepIcon,
                      completed: classes.completedStepIcon,
                    },
                  }}
                  classes={{
                    label:
                      activeStep === index
                        ? classes.activeStepLabel
                        : classes.stepLabel,
                  }}
                >
                  {label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>
          <Box className={classes.stepsContent} style={{ borderRadius: 8 }}>
            {activeStep === steps.length ? (
              <Typography
                component={"span"}
                variant={"body2"}
                className={classes.instructions}
              >
                All steps completed - you&apos;re finished
              </Typography>
            ) : (
              <Typography
                component={"span"}
                variant={"body2"}
                className={classes.instructions}
              >
                {getStepContent(activeStep)}
              </Typography>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    activites: state.activites,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { getActsDatesDispo, getAvailablesActivites },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(InscriptionsLibres);
